import { defineStore } from 'pinia'

export const useLayoutStore = defineStore('layout', {
  state: () => ({
    sidebarCollapsed: false,
    showResults: false,
    newDialogLoadingRef: false,
    isHideTaskList: false,
    deleteDialogVisible: false,
    dialogLoadingRef: false
  }),
  getters: {
    isSidebarCollapsed: (state) => state.sidebarCollapsed
  },
  actions: {
    toggleSidebar(status) {
      this.sidebarCollapsed = status
    },
    setDeleteDialogVisible(status) {
      this.deleteDialogVisible = status
    },
    setShowResults(status) {
      this.showResults = status
    }, // 关闭结果页面
    setNewDialogLoadingRef(status) {
      this.newDialogLoadingRef = status
    },
    setDialogLoadingRef(status) {
      this.dialogLoadingRef = status
    }
  }
})
